import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { Box } from '@mui/material';
type Props = React.ComponentPropsWithoutRef<typeof Box>;

// forwardRef is needed because we print components that are wrapped with this
// and react-to-pdf requires a ref to be passed to the component
export const FlexBox = React.forwardRef<HTMLDivElement, Props>((t0, ref) => {
  const $ = _c(11);
  let children;
  let rest;
  let sx;
  if ($[0] !== t0) {
    ({
      children,
      sx,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
    $[3] = sx;
  } else {
    children = $[1];
    rest = $[2];
    sx = $[3];
  }
  let t1;
  if ($[4] !== sx) {
    t1 = {
      display: "flex",
      ...sx
    };
    $[4] = sx;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== ref || $[8] !== rest || $[9] !== t1) {
    t2 = <Box ref={ref} {...rest} sx={t1}>{children}</Box>;
    $[6] = children;
    $[7] = ref;
    $[8] = rest;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
});
FlexBox.displayName = 'FlexBox';